import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import Activty from './component/activity/index.vue';
import Exchange from './component/exchange/index.vue';
import Channel from './component/channel/index.vue';
let ExchangeManage = class ExchangeManage extends Vue {
    constructor() {
        super(...arguments);
        this.tabs = '1';
        this.tableData = [];
        this.activityId = '';
    }
    handleClick(tabs) {
        this.tabs = tabs.name;
    }
    //活动管理点击兑换码跳转至兑换码管理
    onJumpExchange(id) {
        this.activityId = id;
        this.tabs = '2';
    }
};
ExchangeManage = tslib_1.__decorate([
    Component({
        components: {
            Activty,
            Exchange,
            Channel
        }
    })
], ExchangeManage);
export default ExchangeManage;
